/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementCreateSaleResponse } from './CarpsaleManagementCreateSaleResponse';

export type CarpsaleManagementCreateSaleResponseApiRespoonse = {
    data?: CarpsaleManagementCreateSaleResponse;
    status?: CarpsaleManagementCreateSaleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementCreateSaleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

